var loading = false;
$(function () {
    $(window).scroll(function () {
        if ($(document).scrollTop() >= $(document).height() - $(window).height()) {
            if (loading) return;
            var page = parseInt($('.news-items').attr('data-page')) || 1;
            getList(page + 1);
        }
    });
})

function getList(page) {
    loading = true;
    var path = location.pathname;
    $.get(path + '?page=' + page, function (html) {
        if (html) {
            $('.news-items').append($(html).find('.news-items').html())
            $('.news-items').attr('data-page', page)
        }
        loading = false;
    })
}


//////////////////
// WEBPACK FOOTER
// ./cms/client/js/news.page.js
// module id = 31
// module chunks = 9